
    window.addEventListener('load', () => {
      const loadingBar = document.querySelector('.loading-progress > div')
      // 监听动画结束
      loadingBar.addEventListener('animationend', () => {
        // 👉 动态加载 main.js
        import('/src/main.js');
      })
    })
  